import GreenBox from './GreenBox';

export default GreenBox;
